import { Drawer } from '@/components';
import type { ComponentProps, FC } from 'react';
import { useDrawerState } from '../DrawerStateProvider';
import { MasterTableEditWarning } from '../MasterTableEditWarning';
import { ExpenditureNatureForm } from './ExpenditureNatureForm';

type Props = ComponentProps<typeof ExpenditureNatureForm>;

export const ExpenditureNatureFormDrawer: FC<Props> = ({
  type,
  initialValues,
  onSubmit,
}) => {
  const { drawerState, setDrawerState } = useDrawerState();

  return (
    <Drawer
      open={drawerState.open && drawerState.type === 'expenditure-nature'}
      onClose={() => {
        setDrawerState({ open: false });
      }}
      destroyOnClose
    >
      {type === 'edit' && <MasterTableEditWarning marginBottom={8} />}
      <ExpenditureNatureForm
        type={type}
        initialValues={initialValues}
        onSubmit={onSubmit}
      />
    </Drawer>
  );
};
